import type { NewsArticle } from "@/types";

export const newsArticles: NewsArticle[] = [
  {
    id: "news-1",
    title: "《出轨的味道》第二季定档，暗涌之下谁能全身而退",
    summary: "官方正式宣布《出轨的味道：暗涌》将于本月上线，原班人马回归，故事时间线紧接第一季结局，制作规格全面升级。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20still%20for%20an%20entertainment%20news%20article%2C%20moody%20deep%20blue%20lighting%20with%20warm%20orange%20accents%2C%20abstract%20film%20set%20atmosphere%2C%20soft%20shadows%2C%20elegant%20composition%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=cg-news-01&orientation=landscape",
    category: "资讯",
    publishedAt: "2026-10-12",
    content: [
      "备受期待的情感悬疑剧《出轨的味道：暗涌》正式官宣定档。作为《出轨的味道》系列的第二季，本季将延续沈知微与顾延在信任崩塌之后艰难重建的故事线。",
      "据制作方透露，第二季在叙事结构上做了较大调整，采用了双时间线交叉的方式，让观众在当下的调查与八年前的往事之间来回穿梭，逐步拼凑出真相的全貌。",
      "主创团队表示，本季想探讨的不再只是“背叛”本身，而是背叛发生之后，两个人如何面对彼此、面对自己。这也会是整部剧情感浓度最高的一季。",
      "在第一季中留下悬念的那封匿名信，将在第二季的前三集内给出关键线索，而它背后牵扯出的，是远比婚姻更为复杂的利益纠葛。",
    ],
  },
  {
    id: "news-2",
    title: "专访苏晚：沈知微的每一次崩溃，我都认真经历过",
    summary: "从第一季到特别篇，苏晚用三年时间陪伴沈知微成长。她坦言，这个角色让她重新理解了“原谅”这个词的重量。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20still%20for%20an%20entertainment%20news%20article%2C%20moody%20deep%20blue%20lighting%20with%20warm%20orange%20accents%2C%20abstract%20film%20set%20atmosphere%2C%20soft%20shadows%2C%20elegant%20composition%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=cg-news-02&orientation=landscape",
    category: "评论",
    publishedAt: "2026-10-08",
    content: [
      "谈起沈知微这个角色，苏晚的眼神里有一种特别的郑重。她说，第一次读完剧本时，她在深夜哭了很久，因为那个女人的委屈她太懂了。",
      "“很多人觉得沈知微太软弱，发现真相之后为什么不立刻离开。但真实的婚姻里，离开从来不是一拍两散那么简单。”苏晚这样说。",
      "为了演好崩溃戏，她曾在片场连续工作了十八个小时，只为找到那种“情绪被反复拉扯到极限”的状态。导演喊卡之后，她坐在角落里很久没有说话。",
      "当被问到如果再选一次还会不会接这个角色，苏晚笑了：“会。因为她让我学会了，一个人可以不完美，但依然值得被认真对待。”",
    ],
  },
  {
    id: "news-3",
    title: "幕后花絮：那场雨夜戏拍了整整九个通宵",
    summary: "剧中最令人窒息的那场雨夜对峙，幕后远比镜头里更艰难。剧组分享了这场戏从筹备到最终成片的完整过程。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20still%20for%20an%20entertainment%20news%20article%2C%20moody%20deep%20blue%20lighting%20with%20warm%20orange%20accents%2C%20abstract%20film%20set%20atmosphere%2C%20soft%20shadows%2C%20elegant%20composition%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=cg-news-03&orientation=landscape",
    category: "花絮",
    publishedAt: "2026-10-03",
    content: [
      "对于《出轨的味道》的老观众来说，第一季第七集那场雨夜对峙堪称全剧高光。而这场戏的诞生过程，远比画面呈现的更曲折。",
      "美术组为了营造“湿冷到骨子里”的质感，在布景地面下铺了三层防水膜，并在每一条街道缝隙里埋入微型雾化装置。",
      "两位主演在低温与人工雨水中反复拍摄，导演为了捕捉最真实的一次情绪爆发，一直保留了第九条。成片里用的正是那一条。",
      "苏晚事后回忆：“拍到后面其实已经分不清脸上是雨还是眼泪了，但那种状态恰好就是角色需要的。”",
    ],
  },
  {
    id: "news-4",
    title: "为什么《出轨的味道》能成为年度话题剧",
    summary: "没有大场面，没有强反转，它凭什么让无数观众在深夜追到停不下来？我们从叙事与情感两个维度做一次拆解。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20still%20for%20an%20entertainment%20news%20article%2C%20moody%20deep%20blue%20lighting%20with%20warm%20orange%20accents%2C%20abstract%20film%20set%20atmosphere%2C%20soft%20shadows%2C%20elegant%20composition%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=cg-news-04&orientation=landscape",
    category: "评论",
    publishedAt: "2026-09-28",
    content: [
      "《出轨的味道》最聪明的地方，是它从一开始就承认了一个残酷事实：背叛从来不是故事的开端，而是很多问题的结果。",
      "它把镜头对准了婚姻里那些被忽略的日常——沉默的晚餐、各自刷手机的房间、越来越短的对话，而这些细节恰恰是最戳人的地方。",
      "在叙事节奏上，剧集刻意放慢了推进速度，用大量的留白让观众自己去感受角色的犹豫与挣扎，这种克制反而放大了情感的张力。",
      "或许正因如此，它才能让不同年龄、不同经历的观众，都在沈知微身上看见了自己或身边人的影子。",
    ],
  },
  {
    id: "news-5",
    title: "特别篇《归途》曝首支预告，回到十年前的那个秋天",
    summary: "特别篇将聚焦顾延与沈知微的初遇，官方发布首支预告片，短短一分钟的画面已让不少老观众破防。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20still%20for%20an%20entertainment%20news%20article%2C%20moody%20deep%20blue%20lighting%20with%20warm%20orange%20accents%2C%20abstract%20film%20set%20atmosphere%2C%20soft%20shadows%2C%20elegant%20composition%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=cg-news-05&orientation=landscape",
    category: "资讯",
    publishedAt: "2026-09-22",
    content: [
      "特别篇《出轨的味道：归途》发布首支预告，画面回到十年前的大学校园，年轻的顾延与沈知微在图书馆的窗边第一次相遇。",
      "预告中那句“如果那天我没回头，是不是一切都会不一样”，成为全网讨论的焦点，相关话题在预告发布两小时内登上热搜。",
      "据透露，特别篇将用十二集的篇幅，补完正片中始终没有正面交代的那段往事，也会解释两人之间那道始终无法跨越的隔阂究竟从何而来。",
      "对于追了三年的老观众来说，这部特别篇更像是一封写给故事本身的告白。",
    ],
  },
  {
    id: "news-6",
    title: "从沈知微到苏晴：国产剧里的“她”正在变得复杂",
    summary: "近年来一批女性角色摆脱了单一的受害者或加害者标签，开始在灰色地带里呼吸，《出轨的味道》正是其中的代表。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20still%20for%20an%20entertainment%20news%20article%2C%20moody%20deep%20blue%20lighting%20with%20warm%20orange%20accents%2C%20abstract%20film%20set%20atmosphere%2C%20soft%20shadows%2C%20elegant%20composition%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=cg-news-06&orientation=landscape",
    category: "评论",
    publishedAt: "2026-09-15",
    content: [
      "沈知微不是传统意义上的“好女人”，她会犹豫、会妥协，也会在某个瞬间做出并不体面的选择，但正是这种不完美让她显得真实。",
      "同样，剧中的林蔚、苏晴也并非简单的好人或坏人，她们各有立场、各有苦衷，在伤害别人的同时也在被别人伤害。",
      "创作者没有急着给她们下判断，而是把选择权交还给观众，这种叙事上的克制，是国产剧在人物塑造上的一次进步。",
      "当“她”足够复杂，观众才愿意花时间去理解，而不是简单地站队。",
    ],
  },
  {
    id: "news-7",
    title: "《旧照片里的女人》口碑逆袭，第十集成转折点",
    summary: "开播时并不被看好的《旧照片里的女人》，凭借扎实的悬疑铺垫在中段迎来口碑爆发，评分一路上涨。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20still%20for%20an%20entertainment%20news%20article%2C%20moody%20deep%20blue%20lighting%20with%20warm%20orange%20accents%2C%20abstract%20film%20set%20atmosphere%2C%20soft%20shadows%2C%20elegant%20composition%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=cg-news-07&orientation=landscape",
    category: "资讯",
    publishedAt: "2026-09-10",
    content: [
      "《旧照片里的女人》开播首周反响平平，不少观众认为节奏偏慢。但从第六集开始，前期埋下的伏笔陆续回收，剧情陡然收紧。",
      "第十集那场关于照片底片的对手戏，被观众称为“全剧分水岭”，也直接把评分从七分区间拉到了八分以上。",
      "有评论认为，这部剧证明了悬疑叙事不必依赖密集的反转，只要线索铺得足够扎实，观众的耐心最终会得到回报。",
      "目前该剧仍在更新中，后续走向依旧扑朔迷离。",
    ],
  },
  {
    id: "news-8",
    title: "主创谈结局设计：我们不想给观众一个廉价的答案",
    summary: "面对关于结局的诸多讨论，编剧团队首次回应创作思路，坦言开放式结尾是刻意的选择。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20still%20for%20an%20entertainment%20news%20article%2C%20moody%20deep%20blue%20lighting%20with%20warm%20orange%20accents%2C%20abstract%20film%20set%20atmosphere%2C%20soft%20shadows%2C%20elegant%20composition%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=cg-news-08&orientation=landscape",
    category: "资讯",
    publishedAt: "2026-09-04",
    content: [
      "《出轨的味道》第一季的结局曾引发巨大争议，很多观众希望得到一个明确的答案，但编剧团队选择了留白。",
      "“如果我们让沈知微干脆利落地离婚，或者干脆利落地原谅，那都会是一个太轻易的答案。”编剧在采访中这样说。",
      "他表示，现实里的婚姻很少有一个清晰的句号，更多时候它是一连串没有结论的问号，而这正是他们想呈现的东西。",
      "至于第二季会不会给出答案，编剧卖了个关子：“答案一直都在，只是需要观众再耐心看下去。”",
    ],
  },
  {
    id: "news-9",
    title: "盘点：五部值得一口气刷完的都市情感悬疑剧",
    summary: "如果你喜欢《出轨的味道》的调性，这五部作品同样值得加入片单，它们都擅长在情感的裂缝里藏下悬念。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20still%20for%20an%20entertainment%20news%20article%2C%20moody%20deep%20blue%20lighting%20with%20warm%20orange%20accents%2C%20abstract%20film%20set%20atmosphere%2C%20soft%20shadows%2C%20elegant%20composition%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=cg-news-09&orientation=landscape",
    category: "评论",
    publishedAt: "2026-08-29",
    content: [
      "《出轨的味道》带火了一批“情感悬疑”类型的作品，这类剧集共同的特点，是把悬念埋在人与人的关系里，而不是单纯的案件上。",
      "从《深夜十一点》到《完美妻子的秘密》，它们都在追问同一个问题：当我们说了解一个人，我们究竟了解的是什么。",
      "这些作品的节奏普遍偏慢，需要观众有足够的耐心，但一旦进入状态，那种被情绪逐渐包裹的沉浸感是其他类型难以替代的。",
      "如果你正剧荒，不妨把这五部作品加入片单，按播出顺序刷下来会更有意思。",
    ],
  },
];